// src/components/Header.js
import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import HelpIcon from '@mui/icons-material/Help'
import LanguageIcon from '@mui/icons-material/Language'

const LOGO_SRC = 'https://cdn.shopify.com/s/files/1/0648/6700/8614/files/logo_sade_uzun_png.png?v=1755333505'

// ── Basit ayar paneli ───────────────────────────────────────────────────────────
const HEADER = {
  BG: '#0b0b0b',
  LOGO_HEIGHT: 37,
  CENTER_GAP: 1.25,

  // Başlık (Seri Terminal)
  TITLE_TEXT: 'Seri Terminal',
  TITLE_COLOR: '#1bbb47',
  TITLE_FONT_FAMILY: 'Melete, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  TITLE_FONT_WEIGHT: 400,
  TITLE_LETTER_SPACING: -5,
  TITLE_FONT_SIZE: { xs: 18, sm: 20, md: 24 },
  TITLE_LINE_HEIGHT: 1.1,
  TITLE_OFFSET_Y: +2.5, // px — eksi: yukarı, artı: aşağı
  // ↑ sadece yazıyı oynatır, layout’u bozmaz (transform).
}
// ────────────────────────────────────────────────────────────────────────────────

export default function Header() {
  return (
    <AppBar position="static" sx={{ background: HEADER.BG }}>
      <Toolbar sx={{ position: 'relative' }}>
        {/* SOL */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Button
            sx={{ color: '#5dec75ff', fontWeight: 700, textTransform: 'none' }}
            href="https://kladiora.com/"
            target="_blank"
            endIcon={<LanguageIcon />}
          >
            Web Sitemiz
          </Button>
        </Box>

        {/* ORTA: Logo + Başlık */}
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            alignItems: 'center',
            gap: HEADER.CENTER_GAP
          }}
        >
          <Box component="img" src={LOGO_SRC} alt="Kladiora" sx={{ height: HEADER.LOGO_HEIGHT }} />
          <Typography
            component="h1"
            sx={{
              color: HEADER.TITLE_COLOR,
              fontFamily: HEADER.TITLE_FONT_FAMILY,
              fontWeight: HEADER.TITLE_FONT_WEIGHT,
              fontSize: HEADER.TITLE_FONT_SIZE,
              letterSpacing: HEADER.TITLE_LETTER_SPACING,
              lineHeight: HEADER.TITLE_LINE_HEIGHT,
              transform: `translateY(${HEADER.TITLE_OFFSET_Y}px)`,
            }}
          >
            {HEADER.TITLE_TEXT}
          </Typography>
        </Box>

        {/* SAĞ */}
        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Button
            sx={{ color: '#5dec75ff', fontWeight: 700, textTransform: 'none' }}
            href="https://kladiora.com/pages/contact"
            target="_blank"
            endIcon={<HelpIcon />}
          >
            Destek
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
